import React from 'react';

import I18N_STRINGS from 'Jsx/CheckoutV4/i18n/language';

import InputField, { ChangeState } from '../InputField';

import { validateFullName } from './utils/getFullName';

export interface CardHolderSate {
  name: string;
  isValid: boolean;
}

interface CardHolderInputProps {
  onCardHolderChange: ({ name, isValid }: CardHolderSate) => void;
  cardHolder?: string;
}

const CardHolderInput = ({
  onCardHolderChange,
  cardHolder,
}: CardHolderInputProps) => {
  const { CARD_HOLDER_LABEL } = I18N_STRINGS;

  const validation = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { fullName, fullNameErrorMessage, isFullNameValid } =
      validateFullName({ inputEvent: event, isCreditCardFullName: true });

    return {
      formattedValue: fullName,
      errorState: {
        message: fullNameErrorMessage,
        error: !isFullNameValid,
      },
    };
  };

  const onChange = ({ value, isValid }: ChangeState) => {
    onCardHolderChange({ name: value, isValid });
  };

  return (
    <InputField
      id="cardholder"
      name="cardholder"
      testId="cardholder-field"
      className="mb-24"
      label={CARD_HOLDER_LABEL}
      maxLength={50}
      onChange={onChange}
      validation={validation}
      controlledValue={cardHolder}
    />
  );
};

export default CardHolderInput;
